import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import appFetch from '../../../../api/appFetch.js';
import { MoboOutletMobilitySolutionsUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import LanguageDropdown from '../../../Common/Dropdowns/LanguageDropdown.js';

export default class MobilitySolutionsCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            outletId: this.props.outletId !== undefined ? parseInt(this.props.outletId) : this.props.accessibleMoboOutlets[0]?.id ?? 0,
            language: "nl",
            description: "",
            isVisibleInPlanning: false,
            shortDescription: "",
            checkedForData: false,
            selectedOutletId: 0,
            loading: false,
            redirect: false,
            accessibleMoboOutlets: [],
            requestInProgress: false,
            redirect: null,
            open: true,
            mobilitySolutionWasCreated: false,
            daysOfWeek: []
        };
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/mobilitysolutions" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        this.saveNewMobilitySolution();
    }

    isValidForm = () => {
        const { description } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        return true;
    }

    saveNewMobilitySolution = () => {
        let resources = this.props.resources;
        const { outletId, language, description, isVisibleInPlanning, shortDescription } = this.state;

        if (description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        const json = JSON.stringify({
            language: language,
            description: description,
            isVisibleInPlanning: isVisibleInPlanning,
            shortDescription: shortDescription,
            moboOutletId: outletId
        });

        const url = MoboOutletMobilitySolutionsUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: () => {
                this.setState({
                    updateInProgress: false,
                    mobilitySolutionWasCreated: true,
                    redirect: "/mobilitysolutions"
                });

                DisplayMessage(resources["MobilitySolutionWasSaved"], "success");
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value, copiedOutletId: e.target.value });
    };

    renderForm() {
        const { outletId, language, description, isVisibleInPlanning, shortDescription } = this.state;
        const helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        const resources = this.props.resources;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6"
                            noPlaceholder
                        />
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <LanguageDropdown
                            resources={resources}
                            language={language}
                            onLanguageChange={this.handleChange}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="mobilitysolutions-shortDescription"
                                value={shortDescription} label={resources["ShortDescription"]}
                                variant="outlined" name="shortDescription" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextDescription} id="mobilitysolutions-description"
                                value={description} label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 200 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="mobilitysolutions-is-active" checked={isVisibleInPlanning} onChange={this.handleChangeCheckBox} name="isVisibleInPlanning" color="primary" />}
                            label={resources["IsVisibleInPlanning"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>

                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return (<div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>);
    }

    render() {
        const { redirect, open, mobilitySolutionWasCreated, outletId, description, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: mobilitySolutionWasCreated, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-new-mobilitysolution" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["NewMobilitySolution"]}
                            </Typography>
                            <Button id="mobilitysolutions-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}